import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators, NgModel, FormControl } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { TipoRNTService } from './tipos-rnt.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { ModalListaCategoriasComponent } from 'src/app/shared/layouts/modal-lista-categorias/modal-lista-categorias.component';

@Component({
	selector: 'app-tipos-rnt',
	templateUrl: './tipos-rnt.component.html',
	styleUrls: ['./tipos-rnt.component.scss']
})
export class TiposRntComponent implements OnInit {
  listCategoria: Array<any> = [];

	dataTabla: DatoPaginadoModel;
	headerTipoRNT: Array<string>;
	formTipoRNT: FormGroup;
	selectTipoRNT: any;

	paginaActual: number;

	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	constructor(
    private formBuilder: FormBuilder,
    private tipoRNTService: TipoRNTService,
    private modalService: NgbModal,
    private baseService: BaseServiceService,
    private alertService: AlertsService,) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.createForm();



		this.selectTipoRNT = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.onConsultarTipoRNT(1);
    this.getListCategoria();
    this.headerTipoRNT = ['Descripción', 'Tipo de solicitud', 'Estado', 'Acción'];
	}

	createForm() {
		this.formTipoRNT = this.formBuilder.group({
			descripcion: ['', Validators.required],
			activo: [true],
      categoria: []

		});

		this.filtro = this.formBuilder.group({
			descripcion: [null],
			activo: [null],

		});
	}

	onConsultarTipoRNT(page: number) {
		this.tipoRNTService.getTipoRNT({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onConsultarTipoRNTFiltro(page: number) {
		this.tipoRNTService.getTipoRNT({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarTipoRNT(value);
	}

	onAgregarTipoRNT() {
		this.tipoRNTService.crearTipoRNT({
      tipo_rnt_id: 0,
      descripcion: this.formTipoRNT.get('descripcion').value,
      activo: 1,
      categorias_id: (this.formTipoRNT.get('categoria')?.value).toString()
    })
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarTipoRNT(this.paginaActual);
					this.formTipoRNT.reset();
				}
			});
	}

	onOperarTipoRNT() {
		if (!this.selectTipoRNT) {
			this.onAgregarTipoRNT();
		} else {
			this.onModificarTipoRNT();
		}
	}

	onCargarTipoRNT(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
    entry.categoria = (entry.categorias_ids).map(str => {
      return Number(str)
    });

		this.formTipoRNT.patchValue({
			...entry
		});

		this.selectTipoRNT = entry;
	}

	onEliminarTipoRNT(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.tipoRNTService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					const index = this.dataTabla.items.map(function (e) { return e.tipo_rnt_id; }).indexOf(entry.tipo_rnt_id);
					this.dataTabla.items.splice(index, 1);
					this.selectTipoRNT = null;
					this.formTipoRNT.reset();
				}
			});
		});
	}

	onModificarTipoRNT() {
		this.tipoRNTService.update({
      descripcion: this.formTipoRNT.get('descripcion').value,
      activo: 1,
      categorias_id: (this.formTipoRNT.get('categoria')?.value).toString(),
			tipo_rnt_id: this.selectTipoRNT.tipo_rnt_id
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarTipoRNT(this.paginaActual);
					this.formTipoRNT.reset();
					this.selectTipoRNT = null;
				}
			});
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarTipoRNTFiltro(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	LimpiarTiposRnt() {
		this.formTipoRNT.reset();
		this.selectTipoRNT = null;
		this.createForm();
	}

  getListCategoria(){
    this.baseService.getCategory().subscribe(response => {
      if(response.result){
        if(response.data.length > 0){
          this.listCategoria = response.data;
        } else{
          this.alertService.warn(
            MensajesUsuario.NoDataFound,
            null,
            null
          );
        }
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  cargarCategoriasRnt(idRnt){
    this.tipoRNTService.categoriasRnt(idRnt).subscribe(response => {
      if(response.result){
        let listaCategoriasRnt = response.data;

        const modalRef = this.modalService.open(ModalListaCategoriasComponent,
          {
            centered: true,
            size: 'md',
            backdropClass: 'light-blue-backdrop'
          }
        );

        modalRef.componentInstance.listaCategoriasRnt = listaCategoriasRnt;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }
}
